import apiService from './apiService';

class AuthService {
  async login(username, password) {
    try {
      const response = await apiService.post('/api/v1/auth/login', {
        username,
        password,
      });

      if (response.access_token) {
        localStorage.setItem('access_token', response.access_token);
        localStorage.setItem('refresh_token', response.refresh_token || '');
        localStorage.setItem('isAuthenticated', 'true');

        const userData = response.user || {
          name: username,
          username,
          email: '',
          role: 'admin',
          roles: ['admin']
        };

        localStorage.setItem('userData', JSON.stringify(userData));
        return { success: true, user: userData };
      }

      return { success: false, error: 'Invalid response from server' };
    } catch (error) {
      console.error('Login error:', error);
      return { success: false, error: error.message || 'Login failed' };
    }
  }

  async logout() {
    try {
      const refreshToken = localStorage.getItem('refresh_token');
      if (refreshToken) {
        await apiService.post('/api/v1/auth/logout', {
          refresh_token: refreshToken,
        });
      }
    } catch (error) {
      console.error('Logout error:', error);
    } finally {
      localStorage.removeItem('access_token');
      localStorage.removeItem('refresh_token');
      localStorage.removeItem('isAuthenticated');
      localStorage.removeItem('userData');
      localStorage.removeItem('selectedProject');
    }
  }

  async getUserInfo() {
    try {
      const token = localStorage.getItem('access_token');
      if (!token) throw new Error('No access token found');

      const response = await apiService.get('/api/v1/auth/userinfo');

      const userData = {
        id: response.sub || response.id,
        name: response.name || response.username || 'User',
        email: response.email || '',
        username: response.username,
        role: response.role || 'admin',
        roles: response.roles || ['admin'],
        ...response
      };

      localStorage.setItem('userData', JSON.stringify(userData));
      return userData;
    } catch (error) {
      console.error('Get user info error:', error);
      throw error;
    }
  }

  isAuthenticated() {
    const token = localStorage.getItem('access_token');
    const authState = localStorage.getItem('isAuthenticated');
    return !!(token && authState === 'true');
  }

  getCurrentUser() {
    try {
      const userData = localStorage.getItem('userData');
      return userData ? JSON.parse(userData) : null;
    } catch (error) {
      return null;
    }
  }

  getAccessToken() {
    return localStorage.getItem('access_token');
  }

  async refreshToken() {
    try {
      const refreshToken = localStorage.getItem('refresh_token');
      if (!refreshToken) throw new Error('No refresh token found');

      const response = await apiService.post('/api/v1/auth/refresh', {
        refresh_token: refreshToken,
      });

      if (response.access_token) {
        localStorage.setItem('access_token', response.access_token);
        if (response.refresh_token) {
          localStorage.setItem('refresh_token', response.refresh_token);
        }
        return response.access_token;
      }

      throw new Error('Failed to refresh token');
    } catch (error) {
      console.error('Token refresh error:', error);
      await this.logout();
      throw error;
    }
  }
}

export default new AuthService();
